// membership/get-customer-details
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const ReferralList = () => {
  
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
  const [ searchQuery,setSearchQuery] = useState('');
  const history = useHistory();
  const [packageList, setPackageList] = useState([]);
   const [showModal, setShowModal] = useState(false);
   const [selectedServices, setSelectedServices] = useState([]);


  useEffect(() => {
    fetchbookinghistory();
}, [currentPage]);

const fetchbookinghistory = async () => {
  const token = localStorage.getItem('token');
//   const userId = localStorage.getItem('userIdd');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/cust_membership_referal_details/get-details`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      setPackageList(response.data);
      setIsLogin(false);
  } catch (error) {
    setPackageList([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
  };
  
  // Filter employees before applying pagination
  const filteredUsers = packageList.filter((data) => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (data.shop_name && data.shop_name.toLowerCase().includes(searchLower)) ||
      (data.shop_mobile && data.shop_mobile.toLowerCase().includes(searchLower)) ||
      (data.shop_address && data.shop_address.toLowerCase().includes(searchLower)) ||
      (data.cust_name && data.cust_name.toLowerCase().includes(searchLower)) ||
      (data.cust_mobile && data.cust_mobile.toLowerCase().includes(searchLower)) ||
      (data.cust_refer_name &&
        data.cust_refer_name.toLowerCase().includes(searchLower)) ||
      (data.cust_refer_mobile &&
        data.cust_refer_mobile.toLowerCase().includes(searchLower)) ||
      (data.customer_referal &&
        data.customer_referal.toLowerCase().includes(searchLower)) ||
      (data.plan_name && data.plan_name.toLowerCase().includes(searchLower)) ||
      (data.points && data.points.toString().includes(searchLower)) ||
      (data.referal_code &&
        data.referal_code.toLowerCase().includes(searchLower)) ||
      (data.unused_amount &&
        data.unused_amount.toString().includes(searchLower)) ||
      (data.used_amount && data.used_amount.toString().includes(searchLower))
    );
  });
  
  // Apply pagination to the filtered list
  const paginatedFilteredPackages = filteredUsers.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page
  };
  
  
    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       REFERRAL LIST
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none",padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                <div className="row align-items-center" style={{ margin: "0", padding: "0" }}>
                    <div className="col-12 d-flex justify-content-end align-items-center" style={{ marginBottom: "5px" }}>
                        <Form.Control type="text" placeholder="Search..." className="form-control" onChange={handleSearchInput} style={{ maxWidth: "300px" }}/>
                    </div>
                </div>
                
                <Table className="table align-middle table-nowrap mb-0">
                <thead>
          <tr>
            <th>S.no</th>
            <th>Customer Profile</th>
            {/* <th>Shop Name</th>
            <th>Shop Mobile</th>
            <th>Shop Address</th> */}
            <th>Customer Name</th>
            <th>Customer Mobile</th>
            <th>Customer Refer Profile</th>
            <th>Customer Refer Name</th>
            <th>Customer Refer Mobile No.</th>
            <th>Customer Referal</th>
            {/* <th>Plan Name</th> */}
            <th>Points</th>
            <th>Referal Code</th>
            <th>Unused Amount</th>
            <th>Used Amount</th>
          </tr>
        </thead>
        <tbody>
          {paginatedFilteredPackages.length > 0 ? (
            paginatedFilteredPackages.map((data, index) => (
              <tr key={data.id}>
                <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                <td>
                  <img
                    src={data.cust_profile ? `${var_api}/${data.cust_profile}` : "/images/img/profile.png"} 
                    alt="Profile Image"
                    className="shop-image"
                    width={'50px'}
                    height={'50px'}
                  />
                </td>
                {/* <td>{data.shop_name}</td>
                <td>{data.shop_mobile}</td>
                <td>{data.shop_address}</td> */}
                <td>{data.cust_name}</td>
                <td>{data.cust_mobile}</td>
                <td>
                  <img
                    src={data.cust_refer_profile ? `${var_api}/${data.cust_refer_profile}` : "/images/img/profile.png"} 
                    alt="Refer Profile Image"
                    className="shop-image"
                    width={'50px'}
                    height={'50px'}
                  />
                </td>
                <td>{data.cust_refer_name}</td>
                <td>{data.cust_refer_mobile}</td>
                <td>{data.customer_referal}</td>
                {/* <td>{data.plan_name}</td> */}
                <td>{data.points}</td>
                <td>{data.referal_code}</td>
                <td>{data.unused_amount}</td>
                <td>{data.used_amount}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="16" className="text-center">
                No data available
              </td>
            </tr>
          )}
        </tbody>
          </Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredUsers.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
        </div>
        </>
    )
}

export default ReferralList;